const compactLife = (() => {
  const pageCompactLife = (document.getElementById("pageCompactLife") != null);
  if (pageCompactLife) {



    {
      let secMain = document.querySelector('#jsSecMain');
      let lead = secMain.querySelector('.js-p-lead');
      let txt = secMain.querySelector('.js-p-txt');

      setTimeout(() => {
        lead.classList.add('act')
      }, 600);
      setTimeout(() => {
        txt.classList.add('act')
      }, 1400);
    }



    {
      let secModal = document.querySelector('#jsSecModal');
      let swiperC = null;
      let swiperD = null;

      MicroModal.init({
        disableScroll: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
        onShow: modal => {
          if (modal.id == 'modal-c-2') {
            let slideWrapC = secModal.querySelector('.js-slide-wrap-c');
            let swiperElC = slideWrapC.querySelector('.js-swiper');
            let prevElC = slideWrapC.querySelector('.js-swiper-button-prev');
            let nextElC = slideWrapC.querySelector('.js-swiper-button-next');

            swiperC = new Swiper(swiperElC, {
              effect: 'fade',
              fadeEffect: {
                crossFade: true,
              },
              slidesPerView: 1,
              spaceBetween: 0,
              centeredSlides: true,
              loop: true,
              loopAdditionalSlides: 1,
              speed: 1000,
              // autoplay: {
              //   delay: 3000,
              //   disableOnInteraction: false,
              //   waitForTransition: false,
              // },
              navigation: {
                nextEl: nextElC,
                prevEl: prevElC,
              },
            });
          }

          if (modal.id == 'modal-d-2') {
            let slideWrapD = secModal.querySelector('.js-slide-wrap-d');
            let swiperElD = slideWrapD.querySelector('.js-swiper');
            let prevElD = slideWrapD.querySelector('.js-swiper-button-prev');
            let nextElD = slideWrapD.querySelector('.js-swiper-button-next');

            swiperD = new Swiper(swiperElD, {
              effect: 'fade',
              fadeEffect: {
                crossFade: true,
              },
              slidesPerView: 1,
              spaceBetween: 0,
              centeredSlides: true,
              loop: true,
              loopAdditionalSlides: 1,
              speed: 1000,
              // autoplay: {
              //   delay: 3000,
              //   disableOnInteraction: false,
              //   waitForTransition: false,
              // },
              navigation: {
                nextEl: nextElD,
                prevEl: prevElD,
              },
            });
          }
        },

        onClose: modal => {
          if (modal.id == 'modal-c-2') {
            setTimeout(() => {
              swiperC.destroy(true, true);
              swiperC = null;
            }, 500);
          }
          if (modal.id == 'modal-d-2') {
            setTimeout(() => {
              swiperD.destroy(true, true);
              swiperD = null;
            }, 500);
          }
        },
      });
      // MicroModal.show('modal-c-1');
      // MicroModal.show('modal-d-1');
      // MicroModal.show('modal-c-2');
      // MicroModal.show('modal-d-2');



      let secPoint3 = document.getElementById("jsSecPoint3")
      let typeWraps = secPoint3.querySelectorAll(".js-type-wrap")

      typeWraps.forEach((element, index) => {

        let planArea = element.querySelector(".js-plan-area")
        let planBox = planArea.querySelector(".js-plan-box")
        let iBtns = planBox.querySelectorAll(".js-i-btn")
        let imgImgs = planBox.querySelectorAll(".js-img-img")
        let tabBox = planArea.querySelector(".js-tab-box")
        let tabs = tabBox.querySelectorAll(".js-tab")


        iBtns.forEach((element2, index2) => {
          element2.addEventListener('click', () => {
            if (swiperC) {
              swiperC.slideToLoop(index2)
            }
            if (swiperD) {
              swiperD.slideToLoop(index2)
            }
          });
        });


        tabs.forEach((element2, index2) => {
          element2.addEventListener('click', () => {
            for (let i = 0; i < tabs.length; i++) {
              imgImgs[i].classList.remove('act');
              tabs[i].classList.remove('act');
            }
            imgImgs[index2].classList.add('act');
            tabs[index2].classList.add('act');
          });
        });

        imgImgs[0].classList.add('act');
        tabs[0].classList.add('act');

      });



    }



  }
})();
export default compactLife;